<h2 id="formtop" class="mat-h2 left-text">Work Request {{workRequest.wrNumber}}</h2>
<div *ngIf="this.screenMode === 'user'"  class="mat-mdc-card-subtitle subtitle" [innerHTML]="subtitle"></div>
<form [formGroup]="workRequestForm" #wrForm="ngForm">

    <mat-card class="card-container">
        <!-- 
[class.cdk-visually-hidden]="exp" vs [hidden]="exp" 
btw this is adding a class
I had issues with milestonesand dynamic components, so uses that there to fix it.
I should consider doing it everywhere?

-->

        <!--
    <mat-card-subtitle class="left-text" *ngIf="screenMode=='user'">
        <span [innerHTML]="msg.screenTitle"></span>
    </mat-card-subtitle>
-->

        <div class="wr-progress row">
            <!-- don't put titles that match value of DIV-->
            <div title="Request is Draft" class="progress-bar-draft" role="progressbar" aria-valuenow="20"
                aria-valuemin="0" aria-valuemax="100" [hidden]="progressStatusLevel < 1">Draft </div>

            <div title="Request Submitted" class="progress-bar-submitted" role="progressbar" aria-valuenow="40"
                aria-valuemin="0" aria-valuemax="100" [hidden]="progressStatusLevel < 2">Submitted</div>
            <div title="Request in Internal Review" class="progress-bar-internal-review" role="progressbar"
                aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" [hidden]="progressStatusLevel < 3">Internal
                Review</div>
            <div title="Request In-Progress" class="progress-bar-in-progress" role="progressbar" aria-valuenow="80"
                aria-valuemin="0" aria-valuemax="100" [hidden]="progressStatusLevel < 4">In Progress</div>
            <div title="Request Closed" class="progress-bar-closed" role="progressbar" aria-valuenow="100"
                aria-valuemin="0" aria-valuemax="100" [hidden]="progressStatusLevel < 5">Closed</div>
        </div>
        <div class="wr-progress row">
            <div title="Draft Date" class="progress-bar-draft" role="progressbar" aria-valuenow="20" aria-valuemin="0"
                aria-valuemax="100" [hidden]="progressStatusLevel < 1">{{workRequest.createdDateUTC | date}} </div>

            <div title="Submitted Date" class="progress-bar-submitted" [hidden]="progressStatusLevel < 2">
                {{workRequest.submittedDateUTC | date}}</div>
            <div title="Internal Review Date" class="progress-bar-internal-review" [hidden]="progressStatusLevel < 3">
                {{workRequest.internalReviewDateUTC | date}}</div>
            <div title="In Process Date" class="progress-bar-in-progress" [hidden]="progressStatusLevel < 4">
                {{workRequest.inProgressDateUTC | date}}</div>
            <div title="Closed Date" class="progress-bar-closed" [hidden]="progressStatusLevel < 5">
                {{workRequest.closedDateUTC | date}}</div>
        </div>
    </mat-card>



    <mat-card class="card-container">
        <!--
        <mat-card-actions class="button-bar">
            <button (click)="saveForm()" type="button" [hidden]="btnSaveHide" [disabled]=btnDisableButtons
                mat-raised-button color="primary"><mat-icon>save</mat-icon> Save as Draft</button>
            <button (click)="submitForm()" type="button" [hidden]="btnSubmitHide" [disabled]="btnDisableButtons"
                mat-raised-button color="primary"><mat-icon>save_alt</mat-icon> Submit for Review</button>
            <button (click)="updateForm()" type="button" [hidden]="btnUpdateHide" [disabled]="btnDisableButtons"
                mat-raised-button color="primary"><mat-icon>save_alt</mat-icon> Update</button>
            <button (click)="updatePMForm()" type="button" [hidden]="btnUpdatePMHide" [disabled]="btnDisableUpdatePMButton"
                mat-raised-button color="primary"><mat-icon>save_alt</mat-icon> Update</button>
            <button (click)="inProgressForm()" type="button" [hidden]="btnInProgressHide" [disabled]="btnDisableButtons"
                mat-raised-button color="primary"><mat-icon>save_alt</mat-icon> Set to In Progress</button>
            <button (click)="internalReviewForm()" type="button" [hidden]="btnInternalReviewHide"
                [disabled]="btnDisableButtons" mat-raised-button color="primary"><mat-icon>save_alt</mat-icon> Set to
                Internal Review</button>
            <button (click)="closeRequestForm()" type="button" [hidden]="btnClosedHide" [disabled]="btnDisableButtons"
                mat-raised-button color="primary"><mat-icon>save_alt</mat-icon> Close Request</button>
            <button (click)="deleteForm()" type="button" [hidden]="btnDeleteHide" [disabled]="btnDisableButtons"
                mat-raised-button color="warn" *ngIf="workRequest.workRequestId"><mat-icon>delete</mat-icon>
                Delete</button>
            <button (click)="goBack()" type="button" mat-raised-button color="xxx"><mat-icon
                    class="mat-18">arrow_back_ios</mat-icon> Go Back </button>
            <div class="overall-error">{{formError}}</div>
            -->
            <!-- general users looking at form will not need this extra navigation and the bottom 2 sections will not exist-->
           <!--
            <div *ngIf="screenMode != USER_MODE"><a  class="href" (click)="scrollTo('formtop')">&nbsp;&nbsp;[top] </a>
                <a class="href" (click)="scrollTo('RequestAdministration')"> [request administration] </a>
                <a class="href" *ngIf="workRequestForm.controls['requestType'].value==REQUEST_TYPE_PROJECT" (click)="scrollTo('ProjectManagement')"> [project management]&nbsp;&nbsp;</a></div>


         
        </mat-card-actions>
           -->

        <mat-card-actions class="button-bar2">
        
            <div><button (click)="saveForm()" type="button" [hidden]="btnSaveHide" [disabled]=btnDisableButtons mat-raised-button
                color="primary"><mat-icon>save</mat-icon> Save as Draft</button></div>
        
            <div><button (click)="submitForm()" type="button" [hidden]="btnSubmitHide" [disabled]="btnDisableButtons"
                class="submit-btn"
                mat-raised-button color="primary" matTooltip="Update request and submit to Enterprise Technology" matTooltipPosition="left">
                 Submit for Review <mat-icon iconPositionEnd>send</mat-icon></button></div>

            <div><button (click)="updateForm()" type="button" [hidden]="btnUpdateHide" [disabled]="btnDisableButtons"
                    mat-raised-button color="primary"><mat-icon>save</mat-icon> Update</button></div>

            <div><button (click)="updatePMForm()" type="button" [hidden]="btnUpdatePMHide" [disabled]="btnDisableUpdatePMButton"
                    mat-raised-button color="primary"><mat-icon>save</mat-icon> Update</button></div>

            <div><button (click)="inProgressForm()" type="button" [hidden]="btnInProgressHide" [disabled]="btnDisableButtons"
                    class="in-progress-btn"
                    mat-raised-button color="primary" matTooltip="Update request and set status to In Progress" matTooltipPosition="left">
                    Set to In Progress <mat-icon iconPositionEnd>send</mat-icon> </button></div>
            
            <div><button (click)="internalReviewForm()" type="button" [hidden]="btnInternalReviewHide"
                    class="internal-review-btn"
                    [disabled]="btnDisableButtons" mat-raised-button color="primary" matTooltip="Update request and set status to Internal Review" matTooltipPosition="left"> 
                    Set to Internal Review <mat-icon iconPositionEnd>send</mat-icon></button></div>

            <div><button (click)="closeRequestForm()" type="button" [hidden]="btnClosedHide" [disabled]="btnDisableButtons"
                    class="closed-btn"
                    mat-raised-button color="primary"  matTooltip="Update request and set status to Closed" matTooltipPosition="left">
                    Close Request <mat-icon iconPositionEnd>send</mat-icon></button></div>
            
            <div><button (click)="deleteForm()" type="button" [hidden]="btnDeleteHide" [disabled]="btnDisableButtons"
                    mat-raised-button color="warn" *ngIf="workRequest.workRequestId"><mat-icon>delete</mat-icon>
                    Delete</button></div>
            <div><button (click)="goBack()" type="button" mat-raised-button ><mat-icon
                        class="mat-18 go-back">arrow_back_ios</mat-icon> Go Back </button> </div>  
            <div class="overall-error">{{formError}}</div>
            <div *ngIf="userType.isAdmin && showSkipEmailCheckBox">
                <mat-checkbox class="skip-email" [formControl]="skipEmailNotifications">Skip Notifications</mat-checkbox>
            </div>

            <div class='quick-nav' matTooltip="Quick navigation options" matTooltipPosition="left" *ngIf="screenMode !== USER_MODE">
                <div><a class="href"  (click)="scrollTo('formtop')">[top] </a></div>
                <div><a class="href" (click)="scrollTo('RequestAdministration')"> [request administration] </a></div>
                <div><a class="href" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT"
                    (click)="scrollTo('ProjectManagement')"> [project management]</a></div>
            </div>
        </mat-card-actions>

        <mat-card-content>

            <!--
                        I like the fill appearance, but it is nt showing the label once data is entered.
                        Use legacy and the fill class. ( or use mat-label, which seems the way to go)
                        "
                   -->

            <div class="row" *ngIf="userType.isAdmin">
                <div class="col-sm-6">
                    <mat-form-field class="full-width">
                        <mat-label>Requestor</mat-label>
                        <input type="text"
                            formControlName="requestor" matInput [matAutocomplete]="auto1"
                            
                            matTooltip="{{tooltip.requestor}}"
                            placeholder="{{tooltip.emailLookup}}"
                             />
                        <mat-autocomplete #auto1="matAutocomplete">
                            <mat-option *ngFor="let account of filteredAzureUsers" [value]="account.displayName">
                                {{account.displayName}}
                            </mat-option>
                        </mat-autocomplete>
                        <button type="button" *ngIf="workRequestForm.controls['requestor'].value" matSuffix
                            mat-icon-button aria-label="Clear" [hidden]="btnDisableButtons"
                            (click)="clearADUser(workRequestForm.controls['requestor'])">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="workRequestForm.controls['requestor'].errors">Invalid
                            requestor.
                        </mat-error>

                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>email</mat-label>
                        <input formControlName="requestorEmail" matInput placeholder="email Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>azure id</mat-label>
                        <input formControlName="requestorAzureId" matInput placeholder="azureID Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>work request id</mat-label>
                        <input formControlName="requestorWorkRequestId" matInput placeholder="WorkRequestID Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>resource id</mat-label>
                        <input formControlName="requestorResourceId" matInput placeholder="Resource ID Hidden">
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                   <!--
                    <so-auto-complete [formCtrl]="workRequestForm.controls['department'] | formControl"
                        placeHolder="Please select a department." [options]="departments" [toolTip]="tooltip.department"
                        label="Department" [disableClearBtn]="btnDisableButtons">
                    </so-auto-complete>
                    -->
                    <so-input [formCtrl]="workRequestForm.controls['department'] | formControl" 
                        placeHolder="Enter Department" 
                        label="Department"
                        [readOnlyInd]="departmentReadOnlyInd"
                        [disableClearBtn]="btnDisableButtons">
                    </so-input>
                <!--
                    <so-select [formCtrl]="workRequestForm.controls['department'] | formControl"
                    placeHolder="Please select a department." [options]="departments" [toolTip]="tooltip.department"
                    label="Department" [disableClearBtn]="btnDisableButtons">
                </so-select>
                -->
                </div>
            </div> 
            <div class="row">
                <div class="col-sm-6">
                    <so-select [formCtrl]="workRequestForm.controls['requestType'] | formControl" placeHolder="Select a request type."
                        label="Request Type" errormessage="Pease select a Request Type" [options]="requestTypes"
                        [disableClearBtn]="btnDisableButtons">                    
                    </so-select>


                </div>

                
                <div class="col-sm-6" *ngIf="!userType.isAdmin">
                    <!--
                    <so-select [formCtrl]="workRequestForm.controls['department'] | formControl" 
                    placeHolder="Please enter or select a department."
                    [options]="departments"
                    [toolTip]="tooltip.department"
                    label="Department" [disableClearBtn]="btnDisableButtons">
                    
                </so-select>
                -->
                    
                    <so-input [formCtrl]="workRequestForm.controls['department'] | formControl" 
                        placeHolder="Enter Department" 
                        label="Department"
                        [readOnlyInd]="departmentReadOnlyInd"
                        [disableClearBtn]="btnDisableButtons">
                    </so-input>

                    
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_CONSULTATION">
                    <so-select [formCtrl]="workRequestForm.controls['consultationType'] | formControl" placeHolder="Select a consultation type."
                        label="Consultation Type" errormessage="Pease select a Consultation Type" [options]="consultationTypes"
                        [disableClearBtn]="btnDisableButtons">                    
                    </so-select>

                </div>
            </div>
            <div class="row">

                <div class="col-sm-12">

                    
                    <so-input [formCtrl]="workRequestForm.controls['subject'] | formControl" 
                        placeHolder="Enter a subject for the request." 
                        label="Subject"
                        [disableClearBtn]="btnDisableButtons">
                    </so-input>

                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field class="full-width">
                        <mat-label>Sponsor (Manager, Executive or Director)</mat-label>
                        <input type="text"
                            formControlName="sponsor" matInput [matAutocomplete]="auto1"
                            title="Sponsor (Manager, Executive or Director)"
                            matTooltip="{{tooltip.sponsor}}"
                            [placeholder]="tooltip.emailLookup"
                             />
                        <mat-autocomplete #auto1="matAutocomplete">
                            <mat-option *ngFor="let account of filteredAzureUsers" [value]="account.displayName">
                                {{account.displayName}}
                            </mat-option>
                        </mat-autocomplete>
                        <button type="button" *ngIf="workRequestForm.controls['sponsor'].value" matSuffix
                            mat-icon-button aria-label="Clear" [hidden]="btnDisableButtons"
                            (click)="clearADUser(workRequestForm.controls['sponsor'])">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="workRequestForm.controls['sponsor'].errors">Invalid
                            sponsor.
                        </mat-error>

                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>email</mat-label>
                        <input formControlName="sponsorEmail" matInput placeholder="email Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>azure id</mat-label>
                        <input formControlName="sponsorAzureId" matInput placeholder="azureID Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>work request id</mat-label>
                        <input formControlName="sponsorWorkRequestId" matInput placeholder="WorkRequestID Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>resource id</mat-label>
                        <input formControlName="sponsorResourceId" matInput placeholder="Resource ID Hidden">
                    </mat-form-field>
                </div>
                <div class="col-sm-6 " *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <mat-form-field class="full-width">
                        <mat-label>Application Owner</mat-label>
                        <input type="text" 
                            formControlName="applicationOwner" matInput [matAutocomplete]="auto2"
                            title="Please select application owner." 
                            [placeholder]="tooltip.emailLookup" />
                        <mat-autocomplete #auto2="matAutocomplete">
                            <mat-option *ngFor="let account of filteredAzureUsers" [value]="account.displayName">
                                {{account.displayName}}
                            </mat-option>
                        </mat-autocomplete>
                        <button type="button" *ngIf="workRequestForm.controls['applicationOwner'].value" matSuffix
                            mat-icon-button aria-label="Clear" [hidden]="btnDisableButtons"
                            (click)="clearADUser(workRequestForm.controls['applicationOwner'])">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="workRequestForm.controls['applicationOwner'].errors">Invalid owner.</mat-error>

                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>email</mat-label>
                        <input formControlName="applicationOwnerEmail" matInput placeholder="email Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>azure id</mat-label>
                        <input formControlName="applicationOwnerAzureId" matInput placeholder="azureID Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>work request id</mat-label>
                        <input formControlName="applicationOwnerWorkRequestId" matInput placeholder="WorkRequestID Hidden">
                    </mat-form-field>
                    <mat-form-field class="hide-field">
                        <mat-label>resource id</mat-label>
                        <input formControlName="applicationOwnerResourceId" matInput placeholder="Resource ID Hidden">
                    </mat-form-field>                  
                    <!--
                    <so-input [formCtrl]="workRequestForm.controls['applicationOwner'] | formControl" placeHolder="Enter the owner of the application."
                        label="Application Owner" [disableClearBtn]="btnDisableButtons">
                    </so-input>
                    -->

                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['businessRequirements'] | formControl"
                    placeHolder="Please enter description / issue / business requirements." label="Description / Issue / Business Requirements"
                    errormessage="Description / Issue / Business Requirements should be at least 30 characters."
                    [disableClearBtn]="btnDisableButtons"></so-textarea>

                </div>

            </div>

            <div class="row">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['desiredOutcome'] | formControl"
                    placeHolder="Please enter desired outcome, if known." label="Desired Outcome"
                    errormessage="Invalid entry."
                    [disableClearBtn]="btnDisableButtons"></so-textarea>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['externalInvolvement'] | formControl"
                    placeHolder="Please enter any external involvement. (vendors, ITS, ministries, etc)" label="External Involvement"
                    [disableClearBtn]="btnDisableButtons"></so-textarea>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['requestNotes'] | formControl" placeHolder="Please enter any additional information that might be useful."
                        label="Notes" errormessage="Invalid entry." [disableClearBtn]="btnDisableButtons"></so-textarea>
                </div>
            </div>

            <div class="object-list"
                *ngIf="workRequest.status !== STATUS_CLOSED || (workRequest.status === STATUS_CLOSED && workRequest.requestMilestones && workRequest.requestMilestones.length > 1)">
                <h3 class="align-left mat-h3">Milestones:</h3>
                <div class="add-milestone-form">
                    <ng-container formArrayName="requestMilestones">
                        <ng-container *ngFor="let milestoneForm of requestMilestones.controls; let i = index">

                            <div class="milestone-form-row row" [formGroupName]="i">
                                <div class="col-md-8">
                                    <so-input [formCtrl]="milestoneForm.get('description')! | formControl" placeHolder="Enter a description for the milestone."
                                        label="Description" [disableClearBtn]="btnDisableButtons">
                                    </so-input>
                                
                                </div>
                                <div class="col-md-3">
                                    <so-date-picker [formCtrl]="milestoneForm.get('date')! | formControl" placeHolder="Date. (MM/DD/YYYY)" label="Date "
                                        [disableClearBtn]="btnDisablePMButtons">
                                    </so-date-picker>
                                </div>

                                <mat-icon class="delete-btn" (click)="deleteRequestMilestone(i)" [hidden]="btnDisableButtons">
                                    delete_forever</mat-icon>
                                <mat-form-field [class.cdk-visually-hidden]="true">
                                    <mat-label>hidden work request id</mat-label>
                                    <input formControlName="workRequestId" matInput placeholder="WorkRequestID Hidden">

                                </mat-form-field>
                                <mat-form-field [class.cdk-visually-hidden]="true">
                                    <mat-label>hidden milestone id</mat-label>
                                    <input formControlName="workRequestMilestoneId" matInput
                                        placeholder="WorkRequestMilestoneID Hidden">

                                </mat-form-field>


                            </div>
                        </ng-container>
                    </ng-container>

                    <button type="button" mat-mini-fab (click)="addNewRequestMilestone()" [hidden]="btnDisableButtons"
                        matTooltip="Add a milestone">
                        <span class="sr-only">add milestone</span><mat-icon class="add-course-btn">add</mat-icon>
                    </button>

                </div>
            </div>

            <div *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                <div>&nbsp;</div>
                <h3 class="align-left mat-h2">Additional Project Information</h3>

                <div class="question">Is this project part of the Strategic Planning Process / Operational Plan? 
                    <mat-icon [inline]="true"
                        matTooltip="{{tooltip.spp}}"
                        aria-label="Button that displays a tooltip when focused or hovered over">info</mat-icon>
                    <b>&nbsp;&nbsp;[Priority for non SPP projects are on best effort basis only]</b>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <so-select [formCtrl]="workRequestForm.controls['partOfSppOpPlan'] | formControl" placeHolder="Please select an option." 
                        label="Is this project part of SPP / Operational Plan" labelClass="sr-only"
                            errormessage="Pease select an option" [options]="yesNoOptions" [disableClearBtn]="btnDisableButtons">
                        </so-select>
                    </div>

                </div>

                <div class="row">

                    <div class="col-sm-6">
                        <so-input [formCtrl]="workRequestForm.controls['approvedBudget'] | formControl" placeHolder="Enter the approved budget."
                        label="Approved Budget" [disableClearBtn]="btnDisableButtons">
                    </so-input>

                    </div>
                </div>

                <div class="question">Have you received Executive approval?</div>
                <div class="row">
                  
                        <div class="col-sm-3">
                            <so-select [formCtrl]="workRequestForm.controls['executiveApproval']  | formControl" placeHolder="Please select an option." 
                            labelClass="sr-only" label="Have you received Executive approval"
                                errormessage="Pease select an option" [options]="yesNoOptions" [disableClearBtn]="btnDisableButtons">
                            </so-select>
                        </div>

                    <div class="col-sm-9"
                        *ngIf="workRequestForm.controls['executiveApproval'].value==='Yes'">
                        <so-auto-complete [formCtrl]="workRequestForm.controls['businessSponsor'] | formControl" 
                        placeHolder="Please select a business sponsor."
                        [options]="businessSponsors"
                        label="Business Sponsor" [disableClearBtn]="btnDisableButtons">
                    </so-auto-complete>
                </div>
                    <!--
                        <so-input [formCtrl]="workRequestForm.controls['executiveApprovalName'] | formControl" placeHolder="Enter the executive who approved this request."
                        label="Executive Name" [disableClearBtn]="btnDisableButtons">
                        </so-input>

                  
                    -->

                </div>


                <div class="question">Is there an executive, legislative or financial reason the project needs to be
                    registered at this
                    time?</div>
                <div class="row">
                    <div class="col-sm-3">
                        <so-select [formCtrl]="workRequestForm.controls['registrationRequired'] | formControl" placeHolder="Please select an option." 
                        labelClass="sr-only" label="Is there an executive, legislative or financial reason the project needs to be
                        registered at this
                        time"
                            errormessage="Pease select an option" [options]="yesNoOptions" [disableClearBtn]="btnDisableButtons">
                        </so-select>
                    </div>

                    <div class="col-sm-9"
                        *ngIf="workRequestForm.controls['registrationRequired'].value==='Yes'">
                        
                        <so-input [formCtrl]="workRequestForm.controls['registrationReason'] | formControl" placeHolder="Enter the need for registration."
                        label="Registration Need" [disableClearBtn]="btnDisableButtons">
                        </so-input>

                    </div>


                </div>

                <div class="question">Have you completed a Threat Risk Assessment  or Statement of Sensitivity?
                    <mat-icon [inline]="true"
                        matTooltip="{{tooltip.tra}}"
                        aria-label="Button that displays a tooltip when focused or hovered over">info</mat-icon>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <so-select [formCtrl]="workRequestForm.controls['traSosCompleted'] | formControl" placeHolder="Please select an option." 
                        
                        labelClass="sr-only" label="Have you completed a Threat Risk Assessment or Statement of Sensitivity"
                            errormessage="Pease select an option" [options]="yesNoOptions" [disableClearBtn]="btnDisableButtons">
                        </so-select>
                    </div>

                    <div class="col-sm-9" *ngIf="workRequestForm.controls['traSosCompleted'].value==='Yes'">

                        <so-select [formCtrl]="workRequestForm.controls['sensitivityLevel'] | formControl" placeHolder="What is the Sensitivity Level."
                        toolTip="{{tooltip.sensitivity}}"
                        label="Sensitivity Level" [options]="sensitivityLevels" [disableClearBtn]="btnDisableButtons">
                        </so-select>

                    </div>

                </div>

                <div class="question">Have you completed a Privacy Impact Assessment?
                    <mat-icon [inline]="true"
                        matTooltip="{{tooltip.pia}}"
                        aria-label="Button that displays a tooltip when focused or hovered over">info</mat-icon>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <so-select [formCtrl]="workRequestForm.controls['piaCompleted'] | formControl" placeHolder="Please select an option." 
                        labelClass="sr-only" label="Have you completed a PIA"
                        errormessage="Pease select an option" [options]="yesNoOptions" [disableClearBtn]="btnDisableButtons">
                        </so-select>
                    </div>

                </div>


                <div class="row">
                    <div class="col-sm-6">
                        <so-select [formCtrl]="workRequestForm.controls['applicationType'] | formControl" placeHolder="Please select an application type."
                            label="Application Type" errormessage="Pease select an option" [options]="applicationTypes"
                            [disableClearBtn]="btnDisableButtons">
                        </so-select>

                    </div>

                </div>

                <div class="question">Does the application require Disaster Recovery?</div>
                <div class="row">
                    <div class="col-sm-3">
                        <so-select [formCtrl]="workRequestForm.controls['diasterRecoveryNeeded'] | formControl" placeHolder="Please select an option." 
                        labelClass="sr-only" label="Does the application require Disaster Recovery"
                            errormessage="Pease select an option" [options]="yesNoOptions" [disableClearBtn]="btnDisableButtons">
                        </so-select>
                    </div>

                </div>



                <div class="row">
                    <div class="col-sm-6">

                        <!--
                        <so-select [formCtrl]="workRequestForm.controls['authenticationMethod'] | formControl" placeHolder="Please select an authentication type."
                        label="Authentication Method" errormessage="Pease select an option" [options]="authenticationMethods"
                        [disableClearBtn]="btnDisableButtons">
                    </so-select>
                    -->

                        <so-select [formCtrl]="workRequestForm.controls['authenticationMethod'] | formControl"
                        [options]="authenticationMethods"
                        placeHolder="What Authentication do you plan to use?" label="Authentication Method"
                        [disableClearBtn]="btnDisableButtons"></so-select>

                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <so-input [formCtrl]="workRequestForm.controls['numberOfUsers'] | formControl" placeHolder="Please enter expected number of users."
                        label="Number of Users" [disableClearBtn]="btnDisableButtons">
                        </so-input>
 
                    </div>
                </div>

                <div class="question">Is a public facing URL needed?</div>
                <div class="row">
                    <div class="col-sm-3">
                        <so-select [formCtrl]="workRequestForm.controls['publicFacingURLNeeded'] | formControl" placeHolder="Please select an option." 
                        labelClass="sr-only"  label="Is a public facing URL needed"
                            errormessage="Pease select an option" [options]="yesNoOptions" [disableClearBtn]="btnDisableButtons">
                        </so-select>
                    </div>

                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <so-textarea [formCtrl]="workRequestForm.controls['apiRequirements'] | formControl"
                       
                            placeHolder="Specify any API requirements. If unsure, type 'unsure'" label="API Requirements "
                            errormessage="API Requirements is required"
                            [disableClearBtn]="btnDisableButtons"></so-textarea>
                    </div>
                </div>

            </div>

        </mat-card-content>

    </mat-card>

    <!-- both Admin and PM can see this.-->
    <mat-card id="RequestAdministration" *ngIf="screenMode !== USER_MODE" class="adminFields card-container">
        <mat-card-title class="title-left">Request Administration</mat-card-title>
        <hr/>
        <mat-card-content>
            <div class="row">
                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <so-input [formCtrl]="workRequestForm.controls['projectTitle'] | formControl" placeHolder="Please enter a project title."
                    label="Project Title <span class='incLabel'>(included in status report)</span>" [disableClearBtn]="btnDisablePMButtons" errormessage="Project Title is required.">
                    </so-input>
                </div>    
                <div class="col-sm-6 visibility-buttons" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                   <!--
                    <span class="button-toggle-label">Visibility</span>
                    <mat-button-toggle-group formControlName="restrictedVisibility" aria-label="Font Style">
                        
                        <mat-button-toggle value=true>Restricted</mat-button-toggle>
                        <mat-button-toggle value=false>All Access</mat-button-toggle>
                      </mat-button-toggle-group>
                      -->
                      <mat-form-field class="full-width">

                        <mat-label class="" >Project Visibility</mat-label>
                        <mat-select  matTooltip="toolTip" matTooltipClass="ttformat" placeholder="placeHolder" formControlName="restrictedVisibility">
                          
                            <mat-option *ngFor="let opt of projectVisibility" [value]="opt.key">
                                {{opt.value}}
                            </mat-option>
                        </mat-select>
                        <button type="button"  *ngIf="workRequestForm.controls['restrictedVisibility'].value!==''" matSuffix
                            aria-label="Clear" [hidden]="btnDisableButtons" 
                            (click)="workRequestForm.controls['restrictedVisibility'].setValue('')">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="workRequestForm.controls['restrictedVisibility'].errors">invalid option</mat-error>
                      </mat-form-field>
                
                </div>           
            </div>

            <div class="row">
                <div class="col-sm-6">

                    <mat-form-field class="full-width">
                        <mat-label>Priority</mat-label>
                        <input formControlName="priorityLevel" matInput type="number" min="1" max="5" 
                            matTooltip="{{tooltip.priority}}"
                            placeholder="Enter a value from 1 to 5 with 1 being highest priority." />
                        <button type="button" *ngIf="workRequestForm.controls['priorityLevel'].value" matSuffix
                            mat-icon-button aria-label="Clear" [hidden]="btnDisableButtons"
                            (click)="clearControl(workRequestForm.controls['priorityLevel'])">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="workRequestForm.controls['priorityLevel'].errors">Invalid entry.</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">

                    <so-select [formCtrl]="workRequestForm.controls['ippmStatus'] | formControl" placeHolder="Select an IPPM Status." label="IPPM Status"
                        toolTip="{{tooltip.ippmStatus}}"
                        errormessage="Pease select an IPPM Status" [options]="ippmStatuses" [disableClearBtn]="btnDisableButtons">                  
                    </so-select>

                </div>

                <div class="col-sm-6">

                    <mat-form-field class="full-width">
                        <mat-label>Number of Environments</mat-label>
                        <input formControlName="numberOfEnvironments" matInput type="number" min="1" max="5"
                            placeholder="Enter a value from 1 to 5" />
                        <button type="button" *ngIf="workRequestForm.controls['numberOfEnvironments'].value" matSuffix
                            mat-icon-button aria-label="Clear" [hidden]="btnDisableButtons"
                            (click)="clearControl(workRequestForm.controls['numberOfEnvironments'])">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="workRequestForm.controls['numberOfEnvironments'].errors">Invalid
                            entry.</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_CONSULTATION ">
                    <so-input [formCtrl]="workRequestForm.controls['traPiaSasRating'] | formControl" placeHolder="Please enter the Privacy Impact Assessment / Threat Risk Assessment / Security Assessment Strategy."
                    label="PIA / TRA / SAS Rating" [disableClearBtn]="btnDisableButtons">
                    </so-input>
                </div>

                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                        <so-select [formCtrl]="workRequestForm.controls['tShirtSize'] | formControl" placeHolder="Select T-shirt Size" 
                            label="T-shirt Size" toolTip="{{tooltip.tShirt}}"
                            errormessage="Pease select an option" [options]="tShirtSizes" [disableClearBtn]="btnDisableButtons">
                        </so-select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType']?.value===REQUEST_TYPE_PROJECT">
                    <so-select toolTip="{{tooltip.projectType}}" [formCtrl]="workRequestForm.controls['projectType'] | formControl" placeHolder="Select project type" label="Project Type"
                        errormessage="Pease select an option" [options]="projectTypes" [disableClearBtn]="btnDisableButtons">
                    </so-select>

                </div>
            </div>
            <div class="row">
                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <so-select [formCtrl]="workRequestForm.controls['projectMethodology'] | formControl" placeHolder="Select project methodology"
                        label="Project Methodology" errormessage="Pease select an option" [options]="projectMethodologies"
                        [disableClearBtn]="btnDisableButtons">
                    </so-select>

                </div>
                <div class="col-sm-6" *ngIf="workRequestForm.controls['projectMethodology'].value ===PROJECT_METHODOLOGY_AGILE || workRequestForm.controls['projectMethodology'].value ===PROJECT_METHODOLOGY_HYBRID">
                    <so-input [formCtrl]="workRequestForm.controls['phaseInfo'] | formControl" placeHolder="Please enter any phase information."
                    label="Phase Info" [disableClearBtn]="btnDisableButtons">
                    </so-input>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <so-select [formCtrl]="workRequestForm.controls['projectGovernance']  | formControl" placeHolder="Select project governance"
                        label="Project Governance" errormessage="Pease select an option" [options]="projectGovernanceSources"
                        [disableClearBtn]="btnDisablePMButtons">
                    </so-select>

                </div>

                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <so-select [formCtrl]="workRequestForm.controls['fundingSource'] | formControl" placeHolder="Select funding source"
                        label="Funding Source" errormessage="Pease select an option" [options]="fundingSources"
                        [disableClearBtn]="btnDisablePMButtons">
                    </so-select>

                </div>
            </div>
            <div class="row">
                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <so-select [formCtrl]="workRequestForm.controls['portfolio']  | formControl" placeHolder="Select portfolio"
                        label="Portfolio" errormessage="Pease select an option" [options]="portfolioSources"
                        [disableClearBtn]="btnDisablePMButtons">
                    </so-select>

                </div>

                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <so-select [formCtrl]="workRequestForm.controls['projectCategory'] | formControl" placeHolder="Select project category"
                        label="Project Category" errormessage="Pease select an option" [options]="projectCategorySources"
                        [disableClearBtn]="btnDisablePMButtons">
                    </so-select>

                </div>
            </div>
            
            <div class="row" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['sppInfo'] | formControl"
                    placeHolder="Specify any additional Strategic Planning Process (SPP) information." label="Additional SPP Information"
                    [disableClearBtn]="btnDisableButtons"></so-textarea>

                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <so-select [formCtrl]="workRequestForm.controls['checkpoint'] | formControl" placeHolder="Select checkpoint"
                    label="Checkpoint" errormessage="Pease select an option" [options]="checkpoints"
                    [disableClearBtn]="btnDisableButtons">
                     </so-select>

                </div>

                <div class="col-sm-6" *ngIf="workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT">
                    <so-select [formCtrl]="workRequestForm.controls['trbCheckpoint'] | formControl" placeHolder="Select Technology Review Board checkpoint"
                    toolTip="{{tooltip.trbCheckpoints}}"
                    label="TRB Checkpoint" errormessage="Pease select an option" [options]="trbCheckpoints"
                    [disableClearBtn]="btnDisablePMButtons">
                     </so-select>

                </div>

            </div>
            <div class="object-list"
                *ngIf="workRequest.status !== STATUS_CLOSED || (workRequest.status === STATUS_CLOSED && workRequest.requestResources && workRequest.requestResources.length > 0)">
                <div class="row">
                    <h3 class="col-md-6 align-left mat-h3"  matTooltip="{{tooltip.requestResources}}">Request Resources: <mat-icon>info</mat-icon></h3>
                  
                </div>
                <div class="add-project-resource-form">
                    <ng-container formArrayName="requestResources">
                        <ng-container *ngFor="let projectResourceForm of requestResources.controls; let i = index">

                            <div class="project-resources-form-row row" [formGroupName]="i">
                                <mat-form-field class="col-md-6">
                                    <mat-label>Name</mat-label>
                                    <input type="text"
                                        
                                        formControlName="name" matInput [matAutocomplete]="auto3" 
                                        [placeholder]="tooltip.emailLookup" 
                                        title="Name" />
                                    <mat-autocomplete #auto3="matAutocomplete">
                                        <mat-option *ngFor="let account of filteredAzureUsers"
                                            [value]="account.displayName">
                                            {{account.displayName}}
                                        </mat-option>
                                    </mat-autocomplete>

                                    <button type="button" *ngIf="projectResourceForm.get('name')?.value" matSuffix
                                        mat-icon-button aria-label="Clear" [hidden]="btnDisablePMButtons"
                                        (click)="clearADUser(projectResourceForm.get('name')!)">
                                        <mat-icon>close</mat-icon>
                                    </button>

                                    <mat-error *ngIf="projectResourceForm.get('name')?.errors">Please enter a
                                        name.</mat-error>

                                </mat-form-field>
                                <div class="col-md-5">

                                <so-auto-complete [formCtrl]="projectResourceForm.get('role')! | formControl" 
                                    placeHolder="Please enter project role."
                                    [options]="projectRoles"
                                    label="Role" [disableClearBtn]="btnDisablePMButtons">
                                </so-auto-complete>

                            </div>

                                <mat-icon class="delete-btn" (click)="deleteProjectResource(i)"
                                    [hidden]="btnDisablePMButtons">
                                    delete_forever</mat-icon>
                                <mat-form-field class="hide-field">
                                    <mat-label>email</mat-label>
                                    <input formControlName="email" matInput placeholder="email Hidden">
                                </mat-form-field>
                                <mat-form-field class="hide-field">
                                    <mat-label>azureid</mat-label>
                                    <input formControlName="azureId" matInput placeholder="azureID Hidden">
                                </mat-form-field>
                                <mat-form-field class="hide-field">
                                    <mat-label>work request id</mat-label>
                                    <input formControlName="workRequestId" matInput placeholder="WorkRequestID Hidden">

                                </mat-form-field>
                                <mat-form-field class="hide-field">
                                    <mat-label>resource id</mat-label>
                                    <input formControlName="resourceId" matInput placeholder="Resource ID Hidden">
                                </mat-form-field>


                            </div>
                        </ng-container>
                    </ng-container>

                    <button type="button" mat-mini-fab (click)="addNewProjectResource()" [hidden]="btnDisablePMButtons"
                        matTooltip="Add a project resource">
                        <span class="sr-only">add resource</span><mat-icon class="add-course-btn">add</mat-icon>
                    </button>

                </div>
            </div>
            <div class="row" [style]="'margin-top: 15px;'">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['notes'] | formControl" placeHolder="Please enter any notes." label="Notes"
                        errormessage="Invalid entry." [disableClearBtn]="btnDisableButtons"></so-textarea>
                </div>
            </div>
            <div *ngIf="workRequestForm.controls['requestType'].value!==REQUEST_TYPE_PROJECT" class="row">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['resolution'] | formControl" placeHolder="Please enter a resolution." label="Resolution"
                        errormessage="Resolution is required when closing a work order or consultation." [disableClearBtn]="btnDisableButtons"></so-textarea>
                </div>
            </div>
        </mat-card-content>

    </mat-card>
</form>


    <!-- both admin and PM can see this.-->
    <mat-card id="ProjectManagement" *ngIf="screenMode !== USER_MODE && workRequestForm.controls['requestType'].value===REQUEST_TYPE_PROJECT" class="pmFields card-container">

        <mat-card-title class="title-left">Project Management</mat-card-title>
        <hr>
        <mat-card-content>
            <form [formGroup]="pmForm" #wrForm="ngForm">
            <div class="object-list"
                *ngIf="workRequest.status !== STATUS_CLOSED || (workRequest.status === STATUS_CLOSED && workRequest.stakeholderResources && workRequest.stakeholderResources.length > 1)">
                <h3 class="align-left mat-h3">Stakeholders:</h3>
                <div class="add-stakeholder-resource-form">
                    <ng-container formArrayName="stakeholderResources">
                        <ng-container *ngFor="let stakeholderResourceForm of stakeholderResources.controls; let i = index">

                            <div class="project-stakeholder-form-row row" [formGroupName]="i">
                                <mat-form-field class="col-md-6">
                                    <mat-label>Name</mat-label>
                                    <input type="text"
                                        
                                        formControlName="name" matInput [matAutocomplete]="auto4" 
                                        [placeholder]="tooltip.emailLookup" 
                                        title="Name" />
                                    <mat-autocomplete #auto4="matAutocomplete">
                                        <mat-option *ngFor="let account of filteredAzureUsers"
                                            [value]="account.displayName">
                                            {{account.displayName}}
                                        </mat-option>
                                    </mat-autocomplete>

                                    <button type="button" *ngIf="stakeholderResourceForm.get('name')?.value" matSuffix
                                        mat-icon-button aria-label="Clear" [hidden]="btnDisablePMButtons"
                                        (click)="clearADUser(stakeholderResourceForm.get('name')!)">
                                        <mat-icon>close</mat-icon>
                                    </button>

                                    <mat-error *ngIf="stakeholderResourceForm.get('name')?.errors">Please enter a
                                        name.</mat-error>

                                </mat-form-field>

                                <div class="col-md-3">
                                    <so-input [formCtrl]="stakeholderResourceForm.get('role')! | formControl" placeHolder="Please enterstakeholder role."
                                    label="Role" [disableClearBtn]="btnDisablePMButtons">
                                    </so-input>
                                </div>
                               

                                <mat-icon class="delete-btn" (click)="deleteStakeholderResource(i)"
                                    [hidden]="btnDisablePMButtons">
                                    delete_forever</mat-icon>
                                <mat-form-field class="hide-field">
                                    <mat-label>hidden email</mat-label>
                                    <input formControlName="email" matInput placeholder="email Hidden">
                                </mat-form-field>
                                <mat-form-field class="hide-field">
                                    <mat-label>hidden azure id</mat-label>
                                    <input formControlName="azureId" matInput placeholder="azureID Hidden">
                                </mat-form-field>
                                <mat-form-field class="hide-field">
                                    <mat-label>hidden work request id</mat-label>
                                    <input formControlName="workRequestId" matInput placeholder="WorkRequestID Hidden">

                                </mat-form-field>
                                <mat-form-field class="hide-field">
                                    <mat-label>hidden resource id</mat-label>
                                    <input formControlName="resourceId" matInput placeholder="Resource ID Hidden">
                                </mat-form-field>


                            </div>
                        </ng-container>
                    </ng-container>

                    <button type="button" mat-mini-fab (click)="addNewStakeholderResource()" [hidden]="btnDisablePMButtons"
                        matTooltip="Add a stakeholder">
                        <span class="sr-only">add stakeholder</span><mat-icon class="add-course-btn">add</mat-icon>
                    </button>

                </div>
            </div>

            <div class="row" [style]="'margin-top: 15px;'">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="pmForm.controls['projectDescription'] | formControl"
                    placeHolder="Enter the project description." label="Project Description"
                    [disableClearBtn]="btnDisablePMButtons"></so-textarea>
 
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <so-date-picker [formCtrl]="pmForm.controls['projectStartDate'] | formControl" placeHolder="Please enter project start date. (MM/DD/YYYY)"
                        label="Start Date" [disableClearBtn]="btnDisablePMButtons"
                        errormessage="Start date is required." >
                    </so-date-picker>

                    </div>
                    <div class="col-sm-6">
                        <so-date-picker [formCtrl]="pmForm.controls['projectDeliveryDate'] | formControl" 
                            placeHolder="Please enter a project delivery date. (MM/DD/YYYY)"
                            label="Delivery Date"
                            errormessage="Delivery date must be after project start date." 
                            [disableClearBtn]="btnDisablePMButtons">                        
                        </so-date-picker>

                </div>    
            </div>
 
            <div class="row">
                <div class="col-sm-6">
                    <so-date-picker [formCtrl]="pmForm.controls['projectRevisionDate'] | formControl" placeHolder="Please enter project revision date. (MM/DD/YYYY)"
                    label="Revision Date" [disableClearBtn]="btnDisablePMButtons">
                </so-date-picker>

                    </div>
                    <div class="col-sm-6">
                        <so-input [formCtrl]="pmForm.controls['projectRevisionReason'] | formControl" placeHolder="Please enter a revsion reason."
                        label="Revision Reason" [disableClearBtn]="btnDisablePMButtons">
                        </so-input>

                </div>    
            </div>
            <div class="row">
                <div class="col-sm-6">

                    <!--
                        I'm not using so-select since I want the colors in the options.
                    <so-select [formCtrl]="pmForm.controls['projectStatus'] | formControl" placeHolder="Enter current project status."
                    label="Project Status" errormessage="Pease select a project status" [options]="projectStatuses"
                    [disableClearBtn]="btnDisablePMButtons">                    
                </so-select>
                -->
                
                    <mat-form-field class="full-width">
                        <mat-label>Project Status <span class='incLabel'>(included in status report)</span></mat-label>
                        <mat-select placeholder="Enter current project status" formControlName="projectStatus">
                            <mat-option *ngFor="let st of projectStatuses" [value]="st.key">
                                <span class="{{st.key}}">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{st.value}} 
                            </mat-option>
                        </mat-select>
                        <button type="button" *ngIf="pmForm.controls['projectStatus'].value" matSuffix
                            mat-icon-button aria-label="Clear" [hidden]="btnDisablePMButtons"
                            (click)="clearControl(pmForm.controls['projectStatus'])">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-error *ngIf="pmForm.controls['projectStatus'].errors">Please enter the current project status.</mat-error>
                    </mat-form-field>
                   
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="full-width">
                            <mat-label>Previous Project Status <span class='incLabel'>(included in status report)</span></mat-label>
                            <mat-select placeholder="Enter previously reported project status" formControlName="previousProjectStatus">
                                <mat-option *ngFor="let st of projectStatuses" [value]="st.key">
                                    <span class="{{st.key}}">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{st.value}} 
                                </mat-option>
                            </mat-select>
                            <button type="button" *ngIf="pmForm.controls['previousProjectStatus'].value" matSuffix
                                mat-icon-button aria-label="Clear" [hidden]="btnDisablePMButtons"
                                (click)="clearControl(pmForm.controls['previousProjectStatus'])">
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-error *ngIf="pmForm.controls['previousProjectStatus'].errors">Please enter the previous project status.</mat-error>
                        </mat-form-field>
                </div>    
            </div>
            <div class="row editor-div">
                <mat-label class="editor-label">In Scope</mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                    <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar">
                    </ngx-editor-menu>
                  
                    <ngx-editor [editor]="editor1"  formControlName="inScope" placeholder="Describe what is in scope for the project.">
                    </ngx-editor>
                    </div>
                     
                </div>
            </div>
            <div class="row editor-div">
                <mat-label class="editor-label">Out of Scope</mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                    <ngx-editor-menu [editor]="editor2" [toolbar]="toolbar">
                    </ngx-editor-menu>
                  
                    <ngx-editor [editor]="editor2"  formControlName="outOfScope" placeholder="Describe what is out of scope for the project.">
                    </ngx-editor>
                    </div>

                </div>
            </div>
            <div class="row editor-div">
                <mat-label class="editor-label">Risks</mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                    <ngx-editor-menu [editor]="editor3" [toolbar]="toolbar">
                    </ngx-editor-menu>
                  
                    <ngx-editor [editor]="editor3"  formControlName="risks" placeholder="Describe the risks for the project.">
                    </ngx-editor>
                    </div>

                </div>
            </div>  
            <div class="row editor-div">
                <mat-label class="editor-label">Risk Mitigation</mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                    <ngx-editor-menu [editor]="editor4" [toolbar]="toolbar">
                    </ngx-editor-menu>
                  
                    <ngx-editor [editor]="editor4"  formControlName="riskMitigation" placeholder="Describe the risk mitigation for the project.">
                    </ngx-editor>
                    </div>

                </div>
            </div>      
            <div class="row editor-div">
                <mat-label class="editor-label">Objectives <span class='incLabel'>(included in status report)</span></mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                    <ngx-editor-menu [editor]="editor5" [toolbar]="toolbar">
                    </ngx-editor-menu>
                  
                    <ngx-editor [editor]="editor5"  formControlName="objectives" placeholder="Describe the objectives for the project.">
                    </ngx-editor>
                    </div>

                </div>
            </div>   
            <div class="row editor-div">
                <mat-label class="editor-label">Key Accomplishments <span class='incLabel'>(included in status report and dashboard)</span></mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                    <ngx-editor-menu [editor]="editor6" [toolbar]="toolbar">
                    </ngx-editor-menu>
                  
                    <ngx-editor [editor]="editor6"  formControlName="keyAccomplishments" placeholder="Describe the key accomplishments for the project.">
                    </ngx-editor>
                    </div>

                </div>
            </div>   
            <div class="row editor-div">
                <mat-label class="editor-label">Upcoming Activities  <span class='incLabel'>(included in status report)</span></mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                        <ngx-editor-menu [editor]="editor7" [toolbar]="toolbar">
                        </ngx-editor-menu>
                
                        <ngx-editor [editor]="editor7" formControlName="upcomingActivities"
                            placeholder="Describe the upcoming activities for the project.">
                        </ngx-editor>
                
                    </div>
                </div>
            </div>   
            <div class="row editor-div">
                <mat-label class="editor-label">Decisions <span class='incLabel'>(included in status report)</span></mat-label>
                <div class="col-sm-12">
                    <div class="editor">
                        <ngx-editor-menu [editor]="editor8" [toolbar]="toolbar">
                        </ngx-editor-menu>
                
                        <ngx-editor [editor]="editor8" formControlName="decisions"
                            placeholder="Describe any decision made for the project.">
                        </ngx-editor>
                    </div>

                </div>
            </div>                                              
            <div class="object-list"
                *ngIf="workRequest.status !== STATUS_CLOSED || (workRequest.status === STATUS_CLOSED && workRequest.pmMilestones && workRequest.pmMilestones.length > 1)">
                <div class="row">
                    <h3 class="col-md-6 align-left mat-h3" matTooltip="{{tooltip.pmMilestones}}">PM Milestones:
                        <mat-icon>info</mat-icon></h3>
                        <!--
                    <div class="dashboard-instructions"> (Please select at least one milestone to include in dashboard reporting)</div>
                    -->
            
                </div>
         <div class="add-pm-milestone-form">
                <ng-container formArrayName="pmMilestones">
                    <ng-container *ngFor="let pmMilestoneForm of pmMilestones.controls; let i = index">

                        <div class="pm-milestone-form-row row" [formGroupName]="i">
                            <div class="col-md-4" [style]="' max-width: 40%;margin-right: -15px;'">
                            <so-input [formCtrl]="pmMilestoneForm.get('description')! | formControl" placeHolder="Please enter a description."
                            label="Description" [disableClearBtn]="btnDisablePMButtons">
                            </so-input>
                        </div>

                            <div class="col-md-3" [style]="'max-width: 22%;margin-right: -15px;'">
                                <so-date-picker [formCtrl]="pmMilestoneForm.get('date')! | formControl" placeHolder="Date. (MM/DD/YYYY)" label="Date"
                                [disableClearBtn]="btnDisablePMButtons">
                                 </so-date-picker>
                            </div>
 
                            <div class="col-md-3" [style]="'max-width:18%;margin-right: -15px;'">
                                <so-date-picker [formCtrl]="pmMilestoneForm.get('revisionDate')! | formControl" placeHolder="Revision date. (MM/DD/YYYY)" label="Revision Date"
                                [disableClearBtn]="btnDisablePMButtons">
                                 </so-date-picker>
                            </div>

                            <mat-form-field class="col-md-3" [style]="'max-width: 30%;margin-right: -15px;'">
                                <!--
                                <span class="mat-form-field-label-wrapper">
                                    <span class="mat-form-field-label">Status</span>
                                </span>
                                -->
                                <mat-label>Status</mat-label>
                                <mat-select placeholder="Enter milestone status" formControlName="status">
                                    <mat-option *ngFor="let st of projectStatuses" [value]="st.key">
                                        <span class="{{st.key}}">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{st.value}}
                                    </mat-option>
                                </mat-select>
                                <button type="button" *ngIf="pmMilestoneForm.get('status')?.value" matSuffix mat-icon-button aria-label="Clear"
                                    [hidden]="btnDisablePMButtons" (click)="clearControl(pmMilestoneForm.get('status')!)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            
                            </mat-form-field>
                            <mat-icon class="delete-btn" (click)="deletePMMilestone(i)" [hidden]="btnDisablePMButtons">
                                delete_forever</mat-icon>
                            <div>
                                <!--
                            <mat-checkbox formControlName="showInReporting" [style]="'width: 140px;margin-top: 10px;'">Include in<br/> dashboard</mat-checkbox>
                                -->    
                        </div>
                             

                          
                            <mat-form-field [class.cdk-visually-hidden]="true">
                                <mat-label>workRequestId</mat-label>
                                <input formControlName="workRequestId" matInput placeholder="WorkRequestID Hidden">

                            </mat-form-field>
                            <mat-form-field [class.cdk-visually-hidden]="true">
                                <mat-label>WorkRequestMilestoneID</mat-label>
                                <input formControlName="workRequestMilestoneId" matInput
                                    placeholder="WorkRequestMilestoneID Hidden">

                            </mat-form-field>


                        </div>
                    </ng-container>
                    <mat-error id="milestone-error">{{milestoneReportingError}}</mat-error>
                </ng-container>

                <button type="button" mat-mini-fab (click)="addNewPMMilestone()" [hidden]="btnDisablePMButtons"
                    matTooltip="Add a project milestone">
                    <span class="sr-only">add milestone</span><mat-icon class="add-course-btn">add</mat-icon>
                </button>

            </div>
        </div>
            
        </form>
        </mat-card-content>
    </mat-card>


<mat-expansion-panel class="card-container">
    <mat-expansion-panel-header (click)="getAuditLog()">
        <mat-title>Audit Log</mat-title>
    </mat-expansion-panel-header>


    <ng-template mat-tab-label>
        <span class="full-width" (click)="getAuditLog()">Audit History</span>
    </ng-template>
    <mat-card class="card-container">
        <mat-card-content >
            <div class="row">
                <span class="buttons-right col-md-6">
                </span>

                <span class="buttons-right col-md-6">
                    <button type="button" mat-raised-button (click)="exportData('xlsx')">Excel</button>
                    <button type="button" mat-raised-button (click)="exportData('csv')">CSV</button>
                    <!--button mat-raised-button (click)="exportData('json')">Json</button-->
                    <!--button type="button" mat-raised-button (click)="exportData('txt')">Text</button-->
                </span>

            </div>
            <table mat-table [dataSource]="workRequestAuditView" matTableExporter #exporter="matTableExporter"
                (exportCompleted)="exportCompleted()" class="mat-elevation-z8">

                <ng-container matColumnDef="wrNumber">
                    <th mat-header-cell *matHeaderCellDef> Request ID </th>
                    <td mat-cell *matCellDef="let workRequestAuditView"> {{workRequestAuditView.wrNumber}} </td>
                </ng-container>

                <ng-container matColumnDef="requestorName">
                    <th mat-header-cell *matHeaderCellDef> Requestor </th>
                    <td mat-cell *matCellDef="let workRequestAuditView"> {{workRequestAuditView.requestorName}} </td>
                </ng-container>
                <ng-container matColumnDef="requestorEmail">
                    <th mat-header-cell *matHeaderCellDef> Requestor Email</th>
                    <td mat-cell *matCellDef="let workRequestAuditView"> {{workRequestAuditView.requestorEmail}} </td>
                </ng-container>
                <ng-container matColumnDef="userAction">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let workRequestAuditView"> {{decodeEventType(workRequestAuditView.eventType)}} {{workRequestAuditView.tableName}}</td>
                </ng-container>

                <ng-container matColumnDef="eventUserId">
                    <th mat-header-cell *matHeaderCellDef> Update User </th>
                    <td mat-cell *matCellDef="let workRequestAuditView"> {{workRequestAuditView.eventUserId}} </td>
                </ng-container>
                <ng-container matColumnDef="eventDateUTC">
                    <th mat-header-cell *matHeaderCellDef> Date </th>
                    <td mat-cell *matCellDef="let workRequestAuditView"> {{workRequestAuditView.eventDateUTC |
                        utcToLocalTime:'short'}}</td>
                </ng-container>
                <ng-container matColumnDef="oldValues">
                    <th mat-header-cell *matHeaderCellDef> Old Values </th>
                    <td mat-cell *matCellDef="let workRequestAuditView">
                        <ng-container >
                            <pre [innerHTML]="workRequestAuditView.oldValues"></pre>
                            
                                
                            </ng-container>
                        </td>
                </ng-container>
                <ng-container matColumnDef="newValues">
                    <th mat-header-cell *matHeaderCellDef> New Values </th>
                    <td mat-cell *matCellDef="let workRequestAuditView">
                        <!-- *ngIf="workRequestAuditView.oldValues"-->
                        <ng-container >
                        <pre [innerHTML]="workRequestAuditView.newValues"></pre>
                            
                        </ng-container>

                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedAuditlogColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedAuditlogColumns;"></tr>

            </table>
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </mat-card-content>
    </mat-card>

</mat-expansion-panel>

<mat-expansion-panel class="card-container" *ngIf="screenMode === ADMIN_MODE">
    <mat-expansion-panel-header>
        <mat-title >Admin Tools</mat-title>
    </mat-expansion-panel-header>

    <div class="row">
        <div class="col-sm-6">
            <mat-form-field class="full-width" matTooltip="This function only resets the request status. Any data changes in the form are ignored.">
                <span class="mat-form-field-label-wrapper">
                    <span class="mat-form-field-label">Reset Request Status</span>
                </span>
                <mat-select placeholder=" " [(value)]="resetStatus" >
                    <mat-option *ngFor="let st of statusValues" [value]="st.key">
                        <span class="{{st.key}}">&nbsp;&nbsp;&nbsp;&nbsp;</span> {{st.value}}
                    </mat-option>
                </mat-select>
                <button type="button" *ngIf="resetStatus !== ''" matSuffix mat-icon-button aria-label="Clear"
                    [hidden]="btnDisablePMButtons" (click)="clearControl(pmForm.controls['projectStatus'])">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="col-sm-6" [style]="'margin-top: 20px;'">
            <button (click)="resetRequestStatus()" type="button" mat-raised-button color="primary"><mat-icon>save</mat-icon> Reset
                Status</button>
        </div>
    
    </div>

</mat-expansion-panel>
